import {
  COOKIE_DOMAIN,
  COOKIE_TIMEOUT,
  REFRESH_COOKIE_TIMEOUT, SPOTMENTOR_ENV,
} from '../config';

export const getCookieValue = name => {
  const cookie = document && document.cookie;
  const value = `; ${cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2)
    return parts
      .pop()
      .split(';')
      .shift();
  return '';
};

export const deleteAuthCookie = () => {
  const devDomain = document.location.hostname;
  const cookieDomain = __DEV__ ? devDomain : COOKIE_DOMAIN;

  // document.cookie = `user_access_token=; max-age=0; path=/; domain=${cookieDomain}`;
  // document.cookie = `refresh_token=; max-age=0; path=/; domain=${cookieDomain}`;
  // document.cookie = `user=; max-age=0; path=/; domain=${cookieDomain}`;
  document.cookie = `sessionSubdomain=; max-age=0; path=/; domain=${cookieDomain}`;
  // document.cookie = `hasDemo=; max-age=0; path=/; domain=${cookieDomain}`;
  // document.cookie = `saveSession=; max-age=0; path=/; domain=${cookieDomain}`;
};

export const saveAuthCookie = (
  orgSubdomain,
) => {
  // const hasDemoBool = !!hasDemo;
  const devDomain = document.location.hostname;
  const cookieDomain = __DEV__ ? devDomain : COOKIE_DOMAIN;

  // document.cookie = `user_access_token=${token}; max-age=${REFRESH_COOKIE_TIMEOUT}; path=/; domain=${cookieDomain}`;
  // document.cookie = `refresh_token=${refreshToken}; max-age=${REFRESH_COOKIE_TIMEOUT}; path=/; domain=${cookieDomain}`;
  // document.cookie = `user=${JSON.stringify(
  //   user,
  // )}; max-age=${COOKIE_TIMEOUT}; path=/; domain=${cookieDomain}`;
  document.cookie = `sessionSubdomain=${orgSubdomain}; max-age=${COOKIE_TIMEOUT}; path=/; domain=${cookieDomain}`;
  // document.cookie = `hasDemo=${hasDemoBool}; max-age=${COOKIE_TIMEOUT}; path=/; domain=${cookieDomain}`;
  // document.cookie = `saveSession=${saveSession}; max-age=${COOKIE_TIMEOUT}; path=/; domain=${cookieDomain}`;
};

export const saveCookieConsent = consent => {
  const devDomain = document.location.hostname;
  const cookieDomain = __DEV__ ? devDomain : COOKIE_DOMAIN;

  document.cookie = `cookie_consent=${consent}; max-age=${COOKIE_TIMEOUT}; path=/; domain=${cookieDomain}`;
};

export const saveExtraAliasInfo = details => {
  const devDomain = document.location.hostname;
  const cookieDomain = __DEV__ ? devDomain : COOKIE_DOMAIN;

  document.cookie = `extra_alias_info=${JSON.stringify(
    details,
  )}; max-age=${COOKIE_TIMEOUT}; path=/; domain=${cookieDomain}`;
};

export const clearExtraAliasInfo = () => {
  const devDomain = document.location.hostname;
  const cookieDomain = __DEV__ ? devDomain : COOKIE_DOMAIN;

  document.cookie = `extra_alias_info=; max-age=0; path=/; domain=${cookieDomain}`;
};

const getAuthFromServerCookie = cookie => {
  if (typeof cookie !== 'object') {
    return {};
  }

  const userToken = cookie.user_access_token || '';
  const refreshToken = cookie[SPOTMENTOR_ENV] || '';

  let user = {};

  try {
    user = JSON.parse(decodeURIComponent(cookie.user || ''));
  } catch (err) {
    console.error(err);
    user = {};
  }

  let hasDemo = cookie.hasDemo || 'true';

  if (typeof hasDemo === 'string') {
    hasDemo = hasDemo !== 'false';
  }

  return {
    userToken,
    refreshToken,
    user,
    hasDemo,
  };
};

const getAuthFromBrowserCookie = () => {
  const userToken = getCookieValue('user_access_token');
  const refreshToken = getCookieValue('refresh_token');
  const user = JSON.parse(decodeURIComponent(getCookieValue('user')) || '{}');
  let hasDemo = getCookieValue('hasDemo') || 'true';

  if (typeof hasDemo === 'string') {
    hasDemo = hasDemo !== 'false';
  }

  return {
    userToken,
    refreshToken,
    user,
    hasDemo,
  };
};

export const getAuthFromCookie = process.env.BROWSER
  ? getAuthFromBrowserCookie
  : getAuthFromServerCookie;



// WEBPACK FOOTER //
// ./src/utils/cookie.js